import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { delay, map, startWith, tap, withLatestFrom } from 'rxjs/operators';
import { Sede } from '../../../models/portale/sede';
import { ComponentOutputStatus } from '../../../normalizzazione/component-output-status';

@Component({
  selector: 'lib-tabella-sedi',
  templateUrl: './tabella-sedi.component.html',
  styleUrls: ['./tabella-sedi.component.css']
})
export class TabellaSediComponent implements OnInit {
  @Input()
  sedi$: Observable<Array<Sede>>;
  @Input()
  idSedeSelezionata: string;
  @Input()
  disabled: boolean;

  @Input()
  showLargeHeader: boolean = true;

  dataSource$: Observable<MatTableDataSource<Sede>>;
  selected: FormControl;
  form: FormGroup;
  selection: SelectionModel<Sede>;
  displayedColumns: string[] = ['tipo', 'indirizzo', 'seleziona'];
  alidazioneeSede: boolean;

  @Output()
  done: EventEmitter<ComponentOutputStatus<Array<Sede>>> = new EventEmitter<
    ComponentOutputStatus<Array<Sede>>
  >();
  $subScription: Subscription;
  validazioneeSede: boolean;
  valid: boolean;




  constructor(private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.valid = false;
    this.selection = new SelectionModel<Sede>(false, []);

    this.form = new FormGroup({});
    this.selected = new FormControl({ value: '', disabled: false });
    this.form.addControl('selected', this.selected);

    const changeSelection$ = this.selection.changed.pipe(
      map(change => {
        this.validazioneeSede = change.added.length > 0 ? true : false;
        return ComponentOutputStatus.of(this.validazioneeSede, change.added)
      }),
      tap(_ => console.log("changeSelection", _))
    )

    this.dataSource$ = this.sedi$
      .pipe(
        tap(_ => {
          this.selected.setValue('');
          this.selection.clear();
        }),
        map(sedi => new MatTableDataSource(sedi)),
        tap(_ => console.log("dataSource", _.data)),
        tap(dataSource => {
          this.idSedeSelezionata ?
            this.initialSelection(dataSource.data) :
            null;
          this.ref.detectChanges();
        }
        )
      );

    changeSelection$.subscribe(output => this.done.emit(output));
  }

  initialSelection(sedi: Array<Sede>): void {
    if (this.idSedeSelezionata) {
      setTimeout(() => {
        sedi
          .forEach(row => {
            if (row.id == this.idSedeSelezionata) {
              this.selection.select(row);
            }
          });
      }, 0)
    }

  }
}
